/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { VersionMetadata } from '../../../../api/revisions/types';
import { UiIcon } from '../../../common/icons/ui-icon';
import { UserAvatarForUser } from '../../../common/user-avatar/user-avatar-for-user';
import styles from './revision-list-entry.module.scss';
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { EnvelopeAt, Clock as IconClock } from 'react-bootstrap-icons';
// import { FileText as IconFileText } from 'react-bootstrap-icons'
import { Person as IconPerson } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { getFormattedTime } from './utils';

export interface RevisionListEntryProps {
  active: boolean;
  onSelect: () => void;
  revision: VersionMetadata;
  isCurrentVersion: boolean;
}

/**
 * Renders an entry in the revision list.
 *
 * @param active true if this is the currently selected revision entry.
 * @param onSelect Callback that is fired  when this revision entry is selected.
 * @param revision The metadata for this revision entry.
 */
export const RevisionListEntry: React.FC<RevisionListEntryProps> = ({
  active,
  onSelect,
  revision,
  isCurrentVersion
}) => {
  useTranslation();
  // const { showErrorNotification } = useUiNotifications()

  return (
    <ListGroup.Item
      active={active}
      onClick={onSelect}
      action
      className={`${styles['revision-item']} d-flex flex-column`}>
      <span className={'d-flex flex-row my-1 align-items-center'}>
        <UiIcon icon={IconPerson} className={'mx-2 mr-4'} />
        <UserAvatarForUser
          user={{
            displayName: revision.attributes.user_data.name,
            photo: revision.attributes.user_data.image
          }}
        />
      </span>

      <span className={'d-flex flex-row my-1 align-items-center'}>
        <UiIcon icon={EnvelopeAt} className={'mx-2 mr-4'} />
        <p className='m-0'>{revision.attributes.user_data.email}</p>
      </span>
      <div className='d-flex'>
        <UiIcon icon={IconClock} className='mt-2 mx-2' />
        <div>
          {getFormattedTime(revision.attributes.created_at)}{' '}
          <p>{isCurrentVersion ? ' (Current Version)' : null}</p>
        </div>
      </div>
    </ListGroup.Item>
  );
};
